export const zIndex = {
  level_1: 10, //dropdowns
  level_2: 20, //overlay
  level_3: 30, //dialog /modal
  level_4: 40, //loading
  level_5: 50, //toast
};
